<script>
	export default {
		globalData: {  
		    shopId: 339388,
			wxAppKey: 'xcx_pjltg',
			shopInit: 0,
			shopBase: {},
			userInfo: null,
			devcode: Math.ceil(Math.random() * 1000000000000),
			apiFrom: "PJDSUPER",
			apiUrl: "https://pjlapi.paojd.cn/"
		},
		methods: {
			formatYear: function (btime, etime) {
			    var txt = btime > 0 ? btime.toString().substring(0, 4) + '-' : '-';
			    txt += etime > 0 ? etime.toString().substring(0, 4) : '';
			    return txt;
			},
			toast: function(msg){
				uni.showToast({ title: msg, icon: 'none' });
			},
			mustLogin: function(callback){
				var that = this;
				if (that.globalData.userInfo) {
					callback(that.globalData.userInfo);
				} else {
					uni.navigateTo({ url: '/pages/user/login' });
				}
			},
			getApi: function (method, apiPath, data, loading, callback) {
				var that = this;
			    //method:POST||GET   apiPath:接口名称如super/getB2cGzhInfo data:json接口参数  loading:是否现在加载  1|0  callback  function(data){...}
			    if (that.globalData.shopInit) {
			      that._getApi(method, apiPath, data, loading, callback);
			    } else {
			      that._getApi('GET', 'gzh/getGzhInfo', {}, 1, function (data) {
			        that.globalData.shopInit = 1;
			        that.globalData.shopBase = data;
			        if (apiPath != 'gzh/getGzhInfo') {
			          that._getApi(method, apiPath, data, loading, callback);
			        } else {
			          callback(data);
			        }
			      });
			    }
			},
			_getApi: function (method, apiPath, data, loading, callback) {
				var that = this;
			    data.token = '';
			    data.devcode = that.globalData.devcode;
			    data.from = that.globalData.apiFrom;
			    data.shopid = that.globalData.shopId;
			    if (loading) uni.hideLoading();
			    if (loading) uni.showLoading({ title: '加载中...', mask: true });
			    uni.request({
			      method: method,
			      url: that.globalData.apiUrl + apiPath,
			      data: data,
			      success(res) {
			        uni.hideLoading();
			        if (res.statusCode == 200) {
			          console.log(res.data);
			          if (res.data.hasOwnProperty("status") && res.data.status) {
			            callback(res.data.data);
			            return true;
			          } else if (res.data.hasOwnProperty("code")) {
			            if (res.data.code == 'noLogin') {
			              uni.navigateTo({ url: 'pages/user/login' });
			            }
			            else {
			              that.toast(res.data.data);
			            }
			          } else {
			            that.toast(res.data.data);
			          }
			        } else {
						that.toast( res.errMsg);
			        }
			        return false;
			      }
			    })
			}
		},
		onLaunch: function() {
			this.$scope.getApi('GET', 'gzh/searchGzhItem', {}, 1, function (data) {});
		},
		onShow: function() {
		},
		onHide: function() {
		}
	}
</script>
<style>
   
    @import './common/uni.css';
	
    page {
        background-color: #ededed;
        height: 100%;
        font-size: 28rpx;
        line-height: 1.8;
		color: #333;
    }
	.inline{display: inline-block;}
	::-webkit-scrollbar {width: 0;height: 0;color: transparent;display: none;}
	.flex{display: flex;}
	.mar5{margin:5px;}
	.mar10{margin:10px;}
	.marl5{margin-left:5px;}
	.marr5{margin-right:5px;}
	.marr10{margin-right:10px;}
	.mart0{margin-top:0px;}
	.mart5{margin-top:5px;}
	.mart10{margin-top:10px;}
	.martb5{margin-top:5px;margin-bottom:5px;}
	.martb10{margin-top:20px;margin-bottom:20px;}
	
	.pad0{padding:2px;}
	.pad5{padding:5px;}
	.pad10{padding:10px;}
	.padlr10{padding-left:10px;padding-right:10px;}
	.padtb5{padding-top:5px;padding-bottom:5px;}
	.padtb10{padding-top:10px;padding-bottom:10px;}
	.padt15{padding-top:15px;}
	.padt20{padding-top:20px;}
	
	/**color begin**/
	.orange{color:#ff6800}
	.red,.error{color:red;}
	.red2{color: #e02323;}
	.red3{color: #a51d1d;}
	.choose{color:#e02323}
	.gray{color:gray}
	.gray2{color:#808080;}
	.green{color:green}
	.blue{color:blue;}
	.a_blue{color:#4887fa;}
	.warn,.notice{color:#FF5722}
	.required{color:red;padding:0 3px;font-weight:normal;font-style:normal}
	.black{color:#3d3d3d}
	.bgf{background-color: #fff;}
	
	/**color end**/
	
	/**字体大小 begin**/
	.size14{font-size:14px}
	.size16{font-size:16px}
	.size18{font-size:18px}
	.w100{width:100px;}
	.w150{width:150px;}
	.w200{width:200px;}
	.w250{width:250px;}
	/**字体大小 end**/
	
	.nodata{color:#df0707;padding:10px;font-size:14px;}
	.center{text-align:center;}
	.right{text-align:right;}
	.left{text-align:left;}
	.clear {clear:both;}
	
	.floatl{float:left;}
	.floatr{float:right;}
	.center{text-align:center;}
	.text_left{text-align:left;}
	.loading{text-align:center;margin:10px;}
	
	
	.input-btn{position: relative;display: table;border-collapse: separate;}
	.input-btn .input{display: table-cell;}
	.input-btn .input .input-btn-txt{border: 1px solid #df0707;border-radius: 5px; border-top-right-radius: 0; border-bottom-right-radius: 0;padding:8px 10px 8px 10px;}
	.input-btn .btns{position: relative;font-size: 0; width: 1%; white-space: nowrap; vertical-align: middle;display: table-cell;}
	.input-btn .btns .btn{border: 1px solid #df0707;border-radius: 5px; width:100%;border-top-left-radius: 0;border-bottom-left-radius: 0;padding: 0px 15px 0px 11px;font-size: 15px; color:#fff;   background-color: #df0707;}
	
	.vin-camera>image{position:absolute;width:34px;height:34px;right: 8px;margin-top:3px;}
	
	.top-bar{position:fixed;z-index: 10; top:0;padding:0 16px;line-height:40px; height:40px; background-color: #eee;left:0;right:0;}
	.top-bar-pad{padding-top:40px;}
	.container .weui-cells__title{
	  padding:8px 16px;
	  font-weight: 500;
	  margin:0px;
	  color: #888888;
	  background-color: #f7f7f7;
	}
	.container .weui-cell{font-size:14px;padding:12px 16px;}
	
	
	/**搜索列表**/
	.item-list{}
	.item-list .item-info{position: relative;min-height:100px; border-bottom: 1px solid #eee;}
	.item-list .item-info .item-list-left{float: left;display: inline-block;text-align: center;overflow: hidden;width: 100px;height:100px;}
	.item-list .item-info .item-list-left .item-pic{width: 100px;height: 100px;}
	.item-list .item-info .item-list-right{position: relative;display: block;overflow: hidden;padding-left:10px; box-sizing: border-box;}
	.item-list .item-info .item-name{overflow: hidden;text-overflow: ellipsis;word-break: break-all;}
	.item-list .item-info .item-num{color: #999;}
	.item-list .item-info .item-price{}
	
	/**价格显示**/
	.price-view{color: #df0707;display: inline-block;padding:0 5px; height: 25px; line-height: 25px;}
	.price-view .price-coin{padding-right:2px;font-size:13px;}
	.price-view .price-big{font-size:16px;}
	.price-view .price-small{font-size:13px;}
	.price-view-big .price-coin{font-size:18px;}
	.price-view-big .price-big{font-size:22px;}
	.price-view-big .price-small{font-size:18px;}
	.price-view-del{color: #999;text-decoration:line-through}
	.price-view-del .price-coin, .price-view-del .price-big, .price-view-del .price-small{font-size:16px;}
	
	.uni-list{border-top: 1px solid #eee;border-bottom: 1px solid #eee;}
	.uni-list-item{font-size: 14px;}
	.list-group{
	  padding-top: 8px;
	  padding-bottom: 8px;
	  background-color: #f7f7f7;
	  font-weight: 500;
	  margin-top: -1px;
	  margin-left: 0;
	  padding-left: 15px;
	  color: #aaa;
	}
	.mod3-info{color: #aaa; font-size: 13px;margin-top: 4px;}
</style>
